import React, { useEffect, useState } from "react";
import { Card, Modal } from "react-bootstrap";
import PageContentLoader from "../components/TableLoader";
import TablePagination from "../components/Pagination";
import { useParams, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { getPhoto } from "../../services/UserServices/UserService";
import PageTitle from "../layouts/PageTitle";

export default function USER_PHOTO() {

  const { id } = useParams(); // event id
  const [photos, setPhotos] = useState([]);
  const [loader, setLoader] = useState(false);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const location = useLocation();
  const historyData = location?.state?.history ;
  const itemsPerPage = 10;
const [showPreview, setShowPreview] = useState(false);
const [selectedPhoto, setSelectedPhoto] = useState(null);

  const fetchPhotos = async () => {
    try {
      setLoader(true);
      const res = await getPhoto(currentPage,10,id);
 
      setPhotos(res?.data?.data?.gallery?.gallery || []);
console.log("phddotos",res?.data?.data?.count)
      setTotalPages(res?.data?.data?.count || 0);
    } catch (error) {
      toast.error("Failed to load photos");
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchPhotos();
    console.log("flex",photos)
  }, [currentPage, search]);

  const totalItems = totalPages;
  const total = Math.ceil(totalItems / itemsPerPage);


const handlePhotoPreview = (photo) => {
  setSelectedPhoto(photo);
  setShowPreview(true);
};

  console.log("photos",historyData)
  return (
    <div className="qx-page">
    
{/* 
    <PageTitle
          motherMenu="User List"
          activeMenu={` ${historyData?.user?.hostName ?historyData?.user?.hostName:"User"}  >    ${historyData?.event?.name ?historyData?.event?.name:"Event"}  >    📷 Photos ` }
          pathBack={true}   
        /> */}


         <PageTitle
  breadcrumbs={[
    {
      label: "User List",
      path: "/user-management",
    },
    {
      label: historyData?.user?.hostName || "User",
      path: `/user-details/${historyData?.user?._id}`,
      state: {
        history: {
          user: historyData?.user,
        },
      },
    },
    {
      label: historyData?.event?.name || "Event",
      path: `/user_events/${historyData?.user?._id}`,
      state: {
        history: {
          user: historyData?.user,
          event: historyData?.event,
        },
      },
    },
    {
      label: " 📷 Photos",
    },
  ]}
/>
  

      {loader ? (
        <PageContentLoader message="Loading photos..." />
      ) : (
        <Card className="qx-table-card">
          <Card.Body>
            {photos?.length === 0 && (
              <div className="justify-content-center d-flex my-5">
                ❌ No photos found!
              </div>
            )}

            <div
              className="d-flex flex-wrap gap-4"
              style={{ justifyContent: "flex-start", padding: photos?.length ? "20px" : 0 }}
            >
              {photos?.map((photo) => (
                <Card
                  key={photo?._id}
                  className="shadow"
                  style={{ width: "300px", borderRadius: "12px" }}
                >
                  <Card.Img
                    variant="top"
                    src={`https://managemyshaadib.s3.ap-south-1.amazonaws.com/${photo?.url}`}
                    style={{
                      height: "250px",
                      objectFit: "cover",
                      cursor: "pointer",
                    }}
                    onClick={() => handlePhotoPreview(photo)}
                  />

                  <Card.Body style={{ color: "#A60000" }}>
                    <p style={{ fontSize: "12px" }}>
                      📅 {new Date(photo?.createdAt).toLocaleDateString()}
                    </p>
                  </Card.Body>
                </Card>
              ))}
            </div>

            {photos?.length !== 0 && (
              <TablePagination
                pageCount={total}
                pageValue={currentPage}
                setPage={setCurrentPage}
                total={totalItems}
                pageSize={itemsPerPage}
              />
            )}
          </Card.Body>
        </Card>
      )}

      <Modal
  show={showPreview}
  onHide={() => setShowPreview(false)}
  centered
  size="lg"
>
  <Modal.Header closeButton>
    <Modal.Title style={{ color: "#A60000" }}>
      Photo Preview
    </Modal.Title>
  </Modal.Header>

  <Modal.Body className="text-center">
    {selectedPhoto && (
      <>
        <img
          src={`https://managemyshaadib.s3.ap-south-1.amazonaws.com/${selectedPhoto?.url}`}
          alt="Preview"
          style={{
            width: "100%",
            maxHeight: "70vh",
            objectFit: "contain",
            borderRadius: "10px",
          }}
        />

        <p className="mt-3" style={{ fontSize: "13px", color: "#A60000" }}>
          📅 {new Date(selectedPhoto?.createdAt).toLocaleString()}
        </p>
      </>
    )}
  </Modal.Body>
</Modal>

    </div>
  );
}
